import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const Box = styled.div`
  .add-file {
    line-height: 38px;
    font-size: ${Variables.font_sizes.x_medium};
    color: ${Variables.colors.complementary_700};
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    &.disable {
      opacity: 0.5;
    }
    &:hover {
      background-color: ${Variables.colors.primary_50};
    }
  }

  .add-file-big {
    ${props => {
      if (props.viewWidth) {
        const size = (props.viewWidth - 8 - (4 - 1) * 6) / props.imagesNum; //4 n each row and 8 = scroll bar
        return `
        height:${size}px;
        width:${size}px;`;
      } else {
        return `height:64px;
                  width:64px;`;
      }
    }};
    min-height: 88px;
    min-width: 88px;
    max-height: 100px;
    max-width: 100px;
    border-radius: 4px;
    border: ${Variables.colors.complementary_500} dashed 1px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 6px;
    margin-left: 6px;
    //&:nth-child(4n) {
    //  margin-left: 0;
    //}
    &.disable {
      opacity: 0.5;
    }
    label {
      cursor: pointer;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    i {
      cursor: pointer;
      color: ${Variables.colors.complementary_700};
      &:before {
        margin-left: 0;
        font-size: 20px;
      }
    }
  }
  .input-file {
    display: none;
  }
  .files {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .file {
      ${props => {
        if (props.viewWidth) {
          const size = (props.viewWidth - 8 - (4 - 1) * 6) / props.imagesNum; //4 n each row and 8 = scroll bar
          return `
           height:${size}px;
           width:${size}px;`;
        } else {
          return `height:64px;
                  width:64px;`;
        }
      }};
      min-height: 88px;
      min-width: 88px;
      max-height: 100px;
      max-width: 100px;
      border-radius: 4px;
      border: ${Variables.colors.complementary_400} solid 1px;
      display: flex;
      justify-content: center;
      align-items: center;

      position: relative;
      margin-left: 6px;
      margin-bottom: 6px;
      img {
        cursor: pointer;
        border-radius: 4px;
        border: ${Variables.colors.complementary_400} solid 1px;
        width: 100%;
        ${props => {
          if (props.viewWidth) {
            const size = (props.viewWidth - 8 - (4 - 1) * 6) / props.imagesNum; //4 n each row and 8 = scroll bar
            return `
           height:${size}px;
           width:${size}px;`;
          } else {
            return `height:64px;
                  width:64px;`;
          }
        }};
        max-height: 100px;
        max-width: 100px;
        min-height: 88px;
        min-width: 88px;
        background-position: center;
      }
      //&:nth-child(4n) {
      //  margin-left: 0;
      //}
      i {
        width: 24px;
        height: 24px;
        border-radius: 9999px;
        background-color: ${Variables.colors.complementary_700};
        color: ${Variables.colors.complementary};
        position: absolute;
        bottom: -6px;
        right: -0px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        &:before {
          margin-left: 0;
        }
      }
      .refresh-button-container {
        display: none;
        font-size: 12px;
        color: ${Variables.colors.complementary_600};
        position: absolute;
        padding: 8px;
        z-index: 99;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
`;
